// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__2PDLa","actionColumn":"ReferralSources_actionColumn__3_rmW","textButton":"ReferralSources_textButton__1PXsj"};